import PropTypes from 'prop-types';

const allowedTwoDimensionalDataTableProps = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  renderPlaceholderCell: PropTypes.func,
  noResultsContent: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.element
  ]),
  rowHeadings: PropTypes.arrayOf(
    PropTypes.shape({
      rowId: PropTypes.string.isRequired,
      rowHeadingContent: PropTypes.oneOf([
        PropTypes.string,
        PropTypes.element
      ])
    }).isRequired,
  ).isRequired,
  columnHeadings: PropTypes.arrayOf(
    PropTypes.shape({
      columnId: PropTypes.string.isRequired,
      columnHeadingContent: PropTypes.oneOf([
        PropTypes.string,
        PropTypes.element
      ])
    }).isRequired,
  ).isRequired,
  cells: PropTypes.arrayOf([
    PropTypes.shape({
      headers: PropTypes.shape({
        rowId: PropTypes.string.isRequired,
        columnId: PropTypes.string.isRequired
      }).isRequired,
      renderCellContent: PropTypes.func.isRequired
    })
  ])
};

export { allowedTwoDimensionalDataTableProps };